import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-user-focus-entity-changed',
  templateUrl: './user-focus-entity-changed.component.html',
  // styleUrls: ['./user-focus-entity-selector.component.scss']
})
export class UserFocusEntityChangedComponent {}
